export default "__VITE_ASSET__c6268b02__"